/**
 * Cache-key prefix the drugs list page registers its ListQueryService entries
 * under. The store's mutation effects invalidate this prefix so the list
 * refreshes after a save/update, while other consumers (drug selector,
 * pre-auth, customer prescriptions) that read the NgRx collection are untouched.
 */
export const DRUG_LIST_QUERY_PREFIX = 'drug|list|';
